import React from 'react';
import { SignUp } from '@clerk/react-router';

import './auth.css';

export default function SignUpPage() {
  return (
    <div className="auth-container">
      <SignUp forceRedirectUrl="/dashboard" signInUrl="/login" />
    </div>
  );
}
